import { createElementId, getUnixTimestampUTC, textEnabledDefaults } from "../util/utils";
import { defaultShapeStrokeWidth, ShapeRequiredOnly, shapeSchema } from "./schemas/shape";
import { Point } from "./schemas/canvas-element";
import { ElementTextProperties } from "./canvas-element";
import consts from "../consts";

type ShapeInitOptions = {
  type: string;
  subtype?: string;
  color?: string;
  border?: string;
  dash?: number;
  override?: any;
  libraryPath?: string;
} & ElementTextProperties;

type Size = { width: number; height: number };

const defaultColor = consts.COLOR_PALETTE[7];
const defaultStroke = consts.COLOR_PALETTE[0];

export function placeShape({
  point,
  init,
  actualSize,
  defaultShapeSize,
  rotate,
  sizes,
}: {
  point: Point;
  init: ShapeInitOptions;
  actualSize: Size;
  defaultShapeSize: Size;
  rotate?: number;
  sizes: { fontSize: number; strokeWidth: number; defaultRadius: number };
}) {
  const {
    type,
    subtype,
    color = defaultColor,
    border = defaultStroke,
    dash,
    override,
    font = textEnabledDefaults.font,
    fontSize = sizes.fontSize,
    align = textEnabledDefaults.align,
    textColor = textEnabledDefaults.textColor,
    fontProps = textEnabledDefaults.fontProps,
    libraryPath,
  } = init;
  const { width, height } = defaultShapeSize;
  const isShapeRectangular = type == consts.SHAPES.RECT || type == consts.SHAPES.RECT_ROUNDED;
  let x = 0,
    y = 0,
    scaleX = 1,
    scaleY = 1;
  if (isShapeRectangular) {
    x = point.x - actualSize.width / 2;
    y = point.y - actualSize.height / 2;
    scaleX = actualSize.width / width;
    scaleY = actualSize.height / height;
  } else if (type == consts.CANVAS_ELEMENTS.SHAPE && subtype) {
    x = point.x;
    y = point.y;
    scaleX = actualSize.width / width;
    scaleY = actualSize.height / height;
  } else {
    x = point.x;
    y = point.y;
    scaleX = actualSize.width / (sizes.defaultRadius * 2);
    scaleY = actualSize.height / (sizes.defaultRadius * 2);
  }

  const base: ShapeRequiredOnly = {
    type,
    subtype,
    x,
    y,
    scaleX,
    scaleY,
    fill: override?.color ?? color,
    border: override?.border ?? border,
    strokeWidth: sizes.strokeWidth ?? defaultShapeStrokeWidth,
    dash: override?.dash ?? dash,
    width,
    height,
    rotate,
    radius: sizes.defaultRadius,
    font,
    fontSize,
    align: align as "left" | "center" | "right", // Calm down typescript...
    textColor,
    fontProps,
    libraryPath,
    attachedConnectors: {}, // in canvas-element-base this is optional, but it's actually required
    zIndexLastChangeTime: getUnixTimestampUTC(),
  };
  try {
    const shape = shapeSchema.parse(base);
    return {
      id: createElementId(),
      shape,
    };
  } catch (e) {
    console.error("New shape failed zod.parse", base);
    throw e;
  }
}
